import apiClient from "./apiClient";

// State Assignment APIs (admin SPL)

export const fetchSPLList = async ({ page = 1, page_size = 10, search = "", state_id } = {}) => {
 const params = { page, page_size, search };
 if (state_id) params.state_id = state_id;
 const response = await apiClient.get("/anything/admin/spl-list", { params });
 return response.data;
};

export const fetchSPLStates = async (splId) => {
 const response = await apiClient.get(`/anything/admin/spl-states/${splId}`);
 return response.data.data;
};

export const assignStateToSPL = async (splUserId, stateIds) => {
 const response = await apiClient.post("/anything/admin/assign-state", {
 spl_user_id: splUserId,
 state_ids: stateIds,
 });
 return response.data;
};

export const removeStateFromSPL = async (splUserId, stateIds) => {
 const response = await apiClient.delete("/anything/admin/assign-state", {
 data: {
 spl_user_id: splUserId,
 state_ids: stateIds,
 },
 });
 return response.data;
};

export const bulkAssignStatesToSPLs = async (splIds, stateIds, mode) => {
 const response = await apiClient.post("/anything/admin/bulk-assign-state", {
 spl_ids: splIds,
 state_ids: stateIds,
 mode,
 });
 return response.data;
};

// District Assignment APIs (admin/SPL → PL). Multiple districts per PL.

export const fetchPLList = async ({ page = 1, page_size = 10, search = "", district_id } = {}) => {
 const params = { page, page_size, search };
 if (district_id) params.district_id = district_id;
 const response = await apiClient.get("/anything/spl/pl-list", { params });
 return response.data;
};

export const fetchPLDistricts = async (plId) => {
 const response = await apiClient.get(`/anything/spl/pl-districts/${plId}`);
 return response.data.data;
};

export const assignDistrictsToPL = async (plUserId, districtIds) => {
 const response = await apiClient.post("/anything/spl/assign-district", {
 pl_user_id: plUserId,
 district_ids: districtIds,
 });
 return response.data;
};

export const removeDistrictsFromPL = async (plUserId, districtIds) => {
 const response = await apiClient.delete("/anything/spl/assign-district", {
 data: {
 pl_user_id: plUserId,
 district_ids: districtIds,
 },
 });
 return response.data;
};

export const bulkAssignDistrictsToPLs = async (plIds, districtIds, mode) => {
 const response = await apiClient.post("/anything/spl/bulk-assign-district", {
 pl_ids: plIds,
 district_ids: districtIds,
 mode,
 });
 return response.data;
};

// Block Assignment APIs (admin/SPL/PL → PM)

export const fetchPMList = async ({ page = 1, page_size = 10, search = "", state_id, district_id } = {}) => {
 const params = { page, page_size, search };
 if (state_id) params.state_id = state_id;
 if (district_id) params.district_id = district_id;
 const response = await apiClient.get("/anything/pl/pm-list", { params });
 return response.data;
};

export const fetchPMBlocks = async (pmId) => {
 const response = await apiClient.get(`/anything/pl/pm-blocks/${pmId}`);
 return response.data.data;
};

export const assignBlocksToPM = async (pmUserId, blockIds) => {
 const response = await apiClient.post("/anything/pl/assign-block", {
 pm_user_id: pmUserId,
 block_ids: blockIds,
 });
 return response.data;
};

export const removeBlocksFromPM = async (pmUserId, blockIds) => {
 const response = await apiClient.delete("/anything/pl/assign-block", {
 data: {
 pm_user_id: pmUserId,
 block_ids: blockIds,
 },
 });
 return response.data;
};

export const bulkAssignBlocksToPMs = async (pmIds, blockIds, mode) => {
 const response = await apiClient.post("/anything/pl/bulk-assign-block", {
 pm_ids: pmIds,
 block_ids: blockIds,
 mode,
 });
 return response.data;
};

// School Assignment APIs (admin/PL/PM PO)

export const fetchPOList = async ({ page = 1, page_size = 10, search = "", state_id, district_id, block_id } = {}) => {
 const params = { page, page_size, search };
 if (state_id) params.state_id = state_id;
 if (district_id) params.district_id = district_id;
 if (block_id) params.block_id = block_id;
 const response = await apiClient.get("/anything/pm/po-list", { params });
 return response.data;
};

export const fetchPOSchools = async (poId) => {
 const response = await apiClient.get(`/anything/pm/po-schools/${poId}`);
 return response.data.data;
};

export const checkSchoolAvailability = async (schoolIds) => {
 const response = await apiClient.get("/anything/pm/check-school-availability", {
 params: { school_ids: schoolIds.join(",") },
 });
 return response.data;
};

export const assignSchoolsToPO = async (userId, schoolIds) => {
 const response = await apiClient.post("/anything/pm/assign-school", {
 user_id: userId,
 school_ids: schoolIds,
 });
 return response.data;
};

export const removeSchoolsFromPO = async (userId, schoolIds) => {
 const response = await apiClient.delete("/anything/pm/assign-school", {
 data: {
 user_id: userId,
 school_ids: schoolIds,
 },
 });
 return response.data;
};

export const bulkAssignSchoolsToPOs = async (userIds, schoolIds, mode) => {
 const response = await apiClient.post("/anything/pm/bulk-assign-school", {
 user_ids: userIds,
 school_ids: schoolIds,
 mode,
 });
 return response.data;
};

// Self APIs

export const fetchMyStates = async () => {
 const response = await apiClient.get("/anything/spl/my-states");
 return response.data.data;
};

export const fetchMyDistricts = async () => {
 const response = await apiClient.get("/anything/pl/my-districts");
 return response.data.data;
};

export const fetchMySchools = async () => {
 const response = await apiClient.get("/anything/po/my-schools");
 return response.data.data;
};

export const fetchMyBlocks = async () => {
 const response = await apiClient.get("/anything/pm/my-blocks");
 return response.data.data;
};

export const fetchPMSchools = async () => {
 const response = await apiClient.get("/anything/pm/my-schools");
 return response.data.data;
};
